import React from "react";
import {
    Box,
    FormControl,
    styled,
    TextField,
    Autocomplete
} from "@mui/material";
import STFacilityComponent from "../../../api/StationaryTesting/STFacility";
import STFacilityForm from "./STFacilityForm";
import { getMessage } from "../../../global";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import { GlobalButton, GlobalSecondaryButton } from "../../styles";

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    marginBottom: "20px"
}));

const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    width: "50rem"
}));

const StyledDiv = styled('div')({
    display: 'flex',
    justifyContent: "space-between"
});

const STFacility = (props) => {

    const initialStateFacility = {
        id: undefined,
        stationaryTestFacilityName: "",
        isActive: false,
        isExternal: false,
        externalCoordinatorEmail: ""
    };

    const validationsInitialState =
    {
        facilityName: "",
    };

    const [isAdd, setIsAdd] = React.useState(false);
    const [infoData, setInfoData] = React.useState(initialStateFacility);
    const [facilityList, setFacilityList] = React.useState(null);
    const [invalidField, setInvalidField] = React.useState(validationsInitialState);

    const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
    const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
    const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
    const [modalSimpleText, setModalSimpleText] = React.useState('');

    const { hasAnyRole } = useAuth();
    const canEdit = hasAnyRole([Roles.StationaryTestingSME, Roles.Developer]);

    function closeModalSimpleButton() {
        setModalSimpleButton(false);
    }

    function openModalSimpleButton(title, text, buttonText) {
        setModalSimpleButtonText(buttonText)
        setModalSimpleButton(true);
        setModalSimpleTitle(title);
        setModalSimpleText(text);
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (!validateFields()) {
            if (infoData.id !== undefined)
                saveMethod();
            else {

                STFacilityComponent.get(infoData.stationaryTestFacilityName).then((facilityExists) => {
                    if ((facilityExists !== undefined && facilityExists !== null))
                        openModalSimpleButton('Fail', 'This facility already exist', 'Ok');
                    else saveMethod();
                });
            }
        }
    }

    function saveMethod() {

        let facility = new STFacilityComponent({
            stationaryTestFacilityName: infoData.stationaryTestFacilityName,
            isActive: infoData.isActive,
            isExternal: infoData.isExternal,
            externalCoordinatorEmail: infoData.externalCoordinatorEmail
        });

        if (infoData.id === undefined) {
            STFacilityComponent.add(facility).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Facility saved with success', 'Ok');
                    loadFacilityFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        } else {
            STFacilityComponent.update(facility).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Facility updated with success', 'Ok');
                    loadFacilityFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        }
    }

    function handleChangeIsAdd() {
        setIsAdd(true);
        resetForm();
    }


    function loadFacilityFilter() {
        STFacilityComponent.getAll().then((res) => {
            if (res.length > 0) {
                let array = [];
                array.push({ id: undefined, stationaryTestFacilityName: "" });
                array.push(...res);

                setFacilityList(array);
            }
        });
    }

    function validateFields() {
        let requiredFacilityName = infoData.stationaryTestFacilityName === "" ? getMessage('REQUIRED_FIELD') : "";

        setInvalidField({
            ...invalidField,
            facilityName: requiredFacilityName
        });

        return ((requiredFacilityName !== ""));
    }

    function resetForm() {

        setInfoData(initialStateFacility);
        setInvalidField(validationsInitialState);
    }

    function handleChangeSTFacilityFilter(idSelected) {
        setInfoData(initialStateFacility);

        setInfoData(() => ({
            ...initialStateFacility,
            id: idSelected,
            stationaryTestFacilityName: idSelected
        }));

        setIsAdd(true);

        setInvalidField(validationsInitialState);

        if (idSelected !== "") {
            STFacilityComponent.get(idSelected).then((facility) => {
                if (facility !== null) {

                    setInfoData(() => ({
                        ...infoData,
                        id: idSelected,
                        stationaryTestFacilityName: facility.stationaryTestFacilityName,
                        externalCoordinatorEmail: facility.externalCoordinatorEmail,
                        isExternal: facility.isExternal,
                        isActive: facility.isActive,
                    }));
                }
            });
        }
    }

    React.useMemo(() => {
        if (facilityList === null) {
            loadFacilityFilter();
        }
    }, [facilityList])

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <StyledDiv>
                    <div>
                        <StyledBox>
                            <StyledFormControl sx={{ m: 1, width: "35rem" }} variant='outlined'>

                                <StyledBox sx={{ justifyContent: "space-between" }}>
                                    <Autocomplete
                                        noOptionsText={"Loading Facility..."}
                                        value={infoData.stationaryTestFacilityName === '' ? null : infoData.stationaryTestFacilityName}
                                        onChange={(e, value) => {
                                            handleChangeSTFacilityFilter(value);
                                        }}
                                        disablePortal
                                        options={facilityList ? facilityList.map((facility) => facility.stationaryTestFacilityName) : []}
                                        sx={{ width: "35rem" }}
                                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" margin="none" label="Facility" />}
                                        autoSelect
                                    />

                                    <GlobalSecondaryButton sx={{ width: "8rem", marginLeft:"1rem" }}
                                        variant='contained'
                                        type="button"
                                        onClick={handleChangeIsAdd}
                                    >Add New</GlobalSecondaryButton>

                                </StyledBox>

                            </StyledFormControl>

                        </StyledBox>

                        {isAdd === true && <STFacilityForm
                            infoData={infoData} setInfoData={setInfoData}
                            invalidField={invalidField}
                            handleChangeSTFacilityFilter={handleChangeSTFacilityFilter}
                            canEdit={canEdit}
                        >
                        </STFacilityForm>}

                        {
                            isAdd === true &&
                            <div>
                                <StyledBox sx={{ mb: 1, mt: 2, justifyContent: "space-between" }}>
                                    <GlobalButton sx={{ width: "8rem" }}
                                        variant='contained'
                                        type="submit"
                                        disabled={!canEdit}>Save</GlobalButton>
                                </StyledBox>
                            </div>
                        }

                    </div>

                </StyledDiv>

            </form >

            <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
                <label>
                    {modalSimpleText}
                </label>
            </ModalSimpleButton>

        </div >
    )
}

export default STFacility;